<template>
    <div class="box box-w-1">
        <div class="box-inner">
            <div class="text-center">
                <h2>Thank you for your application to ORNA Security.</h2>
                <p>An email has been sent to your email regarding the next steps for employment. If you are applying from outside of the ORNA office and wish to schedule an interview, please
                    <a href="">click here</a></p>
                <div class="mt-5 pr-5 pl-5">
                    <a :href="'/employee/login'" class="btn btn--outline-primary w-100">log in</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThanksPage'
}

</script>



<style scoped>

</style>
